import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import BiztranControls from "../../biztran_controls/BiztranControls";
import { Typography, Paper, Tooltip } from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import ModalFrame from "../../biztran_controls/Modal_Frame";
import AddProduct from "./AddProduct";
import EditProduct from "./EditProduct";

const SODtlsView = (props) => {
  const classes = useStyles();
  const [isOpen, setOpen] = useState(false);
  const [isEditOpen, setEditOpen] = useState(false);
  const [SOID, setSOID] = useState("");
  const [SalesOrderDtlsID, setSalesOrderDtlsID] = useState("");
  const [QuotationID, setQuotationID] = useState("");
  const [rows, setRows] = useState([]);
  const [TotalGst, setTotalGst] = useState("");
  const [columns, setColumns] = useState([]);
  const [SumofGstAmt, setSumofGstAmt] = useState("");
  const [TotalAmount, setTotalAmount] = useState("");
  const [GSTAmount, setGSTAmount] = useState("");
  const [Description, setDescription] = useState("");
  const [CreatedBy, setCreatedBy] = useState("");
  const [CreatedOn, setCreatedOn] = useState("");
  const [ModifiedBy, setModifiedBy] = useState("");
  const [Delivery, setDelivery] = useState("");
  const [IncoTerms, setIncoTerms] = useState("");
  const [Brand, setBrand] = useState("");
  const [Origin, setOrigin] = useState("");
  const [Warranty, setWarranty] = useState("");
  const [Weight, setWeight] = useState("");
  const [BoxSize, setBoxSize] = useState("");
  const [Payment, setPayment] = useState("");
  const [ModifiedOn, setModifiedOn] = useState("");

  const handleOpenModal = (row) => {
    //debugger;
    setEditOpen(true);
    // if (props.SalesOrderID == undefined) {
    //   setSOID(props.SOMainData[0].id);
    // }
    // else {
    setSOID(props.SalesOrderID);
    // }
    //setEditQTTID(props.EditQTID);
    setSalesOrderDtlsID(row.id);
  };

  const OpenModal = () => {
    //debugger;
    setOpen(true);
    // if (props.SalesOrderID == undefined) {
    //   setSOID(props.SOMainData[0].id);
    //   // setQuotationID(props.SOMainData[0].QuotationID);
    // }
    // else {
    setSOID(props.SalesOrderID);
    // }
    setSalesOrderDtlsID("");
  };

  useEffect(() => {

    if (props.SOMainData !== undefined && props.SOMainData.length > 0) {
      setTotalAmount(props.SOMainData[0].TotalAmount);
      setGSTAmount(props.SOMainData[0].GstAmount);
      setDescription(props.SOMainData[0].Description);
      setCreatedBy(props.SOMainData[0].CreatedBy);
      setCreatedOn(props.SOMainData[0].CreatedOn);
      setModifiedBy(props.SOMainData[0].ModifiedBy);
      setModifiedOn(props.SOMainData[0].ModifiedOn);
      setDelivery(props.SOMainData[0].Delivery);
      setIncoTerms(props.SOMainData[0].IncoTerms);
      setBrand(props.SOMainData[0].Make);
      setOrigin(props.SOMainData[0].Origin);
      setWarranty(props.SOMainData[0].Warranty);
      setWeight(props.SOMainData[0].Weight);
      setBoxSize(props.SOMainData[0].BoxSize);
      setPayment(props.SOMainData[0].PaymentTerms);
    }
  }, [props.SOMainData]);

  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: ".",
        renderCell: (params) => (
          <strong>
            {" "}
            <a
              href="javascript:;"
              onClick={() => {
                handleOpenModal(params);
              }}
            >
              <EditIcon fontSize="small" />
            </a>{" "}
          </strong>
        ),
        // renderCell: (params) => (<strong> <a href="javascript:;"  >Select</a> </strong> ),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 34,
      },
      {
        field: "Seq",
        headerName: "Sr.",
        type: 'number',
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 100,
      },
      {
        field: "ModelCode",
        headerName: "Model Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 163,
        //localeText={{columnHeaderSortIconLabel: 'Sortieren'}}
      },
      {
        field: "ProductName",
        headerName: "Product Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => (
          <Tooltip title={params.row.ProductName} >
            <span className="table-cell-trucate">{params.row.ProductName}</span>
          </Tooltip>
        )
      },
      {
        field: "Quantity",
        type: 'number',
        headerName: "Qty",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 100,
      },
      {
        field: "DeliveryDate",
        headerName: "DeliveryDate",
        type: 'Date',
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      {
        field: "Rate",
        headerName: "RateUSD",
        type: 'number',
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "RateINR",
        headerName: "RateINR",
        type: 'number',
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 140,
      },
      {
        field: "CgstPer",
        headerName: "GST %",
        type: 'number',
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },

      {
        field: "DiscountPer",
        headerName: "Dis %",
        type: 'number',
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 120,
      },

      {
        field: "TotalAmount",
        headerName: "Total Amount",
        type: 'number',
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "TotalAmountINR",
        headerName: "TotalAmountINR",
        type: 'number',
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
    ];
    setColumns(gridCols);

    if (props.SODtlsData != null && props.SODtlsData != undefined && props.SODtlsData.length > 0) {
      let SumofGstAmt = 0.00;
      for (let i = 0; i < props.SODtlsData.length; i++) {
        // debugger;
        // SumofGstAmt = Number(Number(SumofGstAmt).toFixed(2) + Number(props.QuotationDtlsData[i]["TotalGstAmt"]).toFixed(2)).toFixed(2);
        SumofGstAmt = Number(parseFloat(SumofGstAmt) + parseFloat(props.SODtlsData[i]["TotalGstAmt"])).toFixed(2);

      }
      // setTotalAmount(SumofGstAmt);
      setSumofGstAmt(SumofGstAmt);
      setRows(props.SODtlsData);

      const TDis = props.SODtlsData[0].DiscountAmount;
      const TOA = props.SODtlsData[0].OtherCharges1Amt;
      const TOA2 = props.SODtlsData[0].OtherCharges2Amt;
      const TGST = ((SumofGstAmt - TDis) + TOA + TOA2);
      const TotalGst = TGST * props.SODtlsData[0].GstPer / 100;
      setTotalGst((TotalGst).toFixed(2));
    }
    else {
      setRows([]);
    }
  }, [props.SODtlsData]);




  return <Paper style={{ paddingLeft: 10, paddingRight: 10 }}>
    <h2 style={{ textDecoration: "underline", textDecorationColor: "#0096FF", textDecorationThickness: 5, }}>
      DETAILS
    </h2>
    <Typography className={classes.headerCmn} noWrap>
      Product Details
      <div style={{ width: "100%" }}>
        <div style={{ float: "right" }}>
          <BiztranControls.Button
            text="Add New"
            style={{ margin: "0.2rem", height: "1.6rem" }}
            startIcon={<AddCircleOutlineIcon />}
            onClick={() => {
              OpenModal();
            }}
          />
        </div>
      </div>
    </Typography>
    <Grid spacing={1} container style={{ marginTop: 7, paddingRight: 10 }}>
      <BiztranControls.DataGrid
        rowHeight={25}
        rows={rows}
        columns={columns}
        checkboxSelection={false}
        hideFooterPagination={false}
        Height="340px"
        Width="100%"
      />
      <ModalFrame
        title="Add Product"
        maxWidth="lg"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <AddProduct
          SOID={SOID}
          SalesOrderDtlsID={SalesOrderDtlsID}
          // QuotationID={QuotationID}
          setOpen={setOpen}
          getByIDData={props.PopulateData}
        />
      </ModalFrame>
      <ModalFrame
        title="Edit Product"
        maxWidth="md"
        isOpen={isEditOpen}
        setOpen={setEditOpen}
      >
        <EditProduct
          SOID={SOID}
          SalesOrderDtlsID={SalesOrderDtlsID}
          setOpen={setEditOpen}
          getByIDData={props.PopulateData}
        />
      </ModalFrame>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Total Amount:</h5>
        <h5>{TotalAmount}</h5>
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>GST Amount:</h5>
        <h5>{TotalGst}</h5>
      </Grid>
      {/* <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Description:</h5>
        <h5>{Description}</h5>
      </Grid> */}
      <Grid item xs={12} className={classes.headerCmn}>
        Terms & Conditions
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Delivery:</h5>
        <h5>{Delivery}</h5>
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Inco Terms:</h5>
        <h5>{IncoTerms}</h5>
      </Grid>
      {/* <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Brand:</h5>
        <h5>{Brand}</h5>
      </Grid> */}
      {/* <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Origin:</h5>
        <h5>{Origin}</h5>
      </Grid> */}
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Warranty:</h5>
        <h5>{Warranty}</h5>
      </Grid>
      {/* <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Weight:</h5>
        <h5>{Weight}</h5>
      </Grid> */}
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>BoxSize:</h5>
        <h5>{BoxSize}</h5>
      </Grid>
      {/* <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Payment:</h5>
        <h5>{Payment}</h5>
      </Grid> */}
      <Grid item xs={12} className={classes.headerCmn}>
        System Information
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Created By:</h5>
        <h5>{CreatedBy}</h5>
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Last Modified By:</h5>
        <h5>{ModifiedBy}</h5>
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Created On:</h5>
        <h5>{CreatedOn}</h5>
      </Grid>
      <Grid item xs={6} container direction="row">
        <h5 style={{ width: 120 }}>Modified On:</h5>
        <h5>{ModifiedOn}</h5>
      </Grid>
    </Grid>
  </Paper>;
};

const useStyles = makeStyles((theme) => ({
  header: {
    width: "100%",
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "1.7rem",
    fontSize: "1.8rem",
    display: "flex",
    flexDirection: "row",
  },
  headertext:
  {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    display: "flex",
    flexDirection: "row",
    //   borderRadius: "1rem",
  },
  headerCmn: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    fontSize: "1rem",
    display: "flex",
    flexDirection: "row",
    //margin: "0.3rem",
    fontWeight: "bold",
  },
}));


export default SODtlsView;